import React, {useEffect, useState, useMemo, useCallback} from 'react';
import {Image, Text, TouchableOpacity, View, Alert} from 'react-native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import Counter from './Counter/Counter';
import {styles} from './styles';
import {Images} from '../../../../constants/Images';
import {useBagStore} from '../../../../store/BagStore';
import {calculatePriceBasedOnQuantity} from '../../../../utils/price';
import ComboProduct from '../../../ProductDetails/ComboProduct/ComboProduct';
import { useNavigation } from '@react-navigation/native';
import { NavigationProps } from '../../../../navigation/Routes';
import { AppRoutes } from '../../../../navigation/Routes.types';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import AviseMeModal from '../../../../components/AviseMeModal/AviseMeModal';
import StockNotificationService from '../../../../services/StockNotificationService/StockNotificationService';
import ProductFavoriteService from '../../../../services/ProductFavoriteService/ProductFavoriteService';
import PromotionBadge from '../../../../components/PromotionBadge/PromotionBadge';
import {useFavoritesStore} from '../../../../store/FavoritesStore';

interface IProductList {
  title: string;
  description: string;
  image: string;
  onPress: () => void;
  AddBag: (count: number) => void;
  item: IProduct;
  clientCode?: string;
  hideFavoriteButton?: boolean;
  containerStyle?: object;
}

const ProductList = React.memo(
  ({AddBag, image, item, description, onPress, clientCode, hideFavoriteButton, containerStyle }: IProductList) => {
    const cartKey = item.is_promotion ? `${item.sku}_promo` : item.sku;
    const otherKey = item.is_promotion ? item.sku : `${item.sku}_promo`;
    const products = useBagStore(state => state.products);
    const [count, setCount] = useState<number>(
      products.find(prod => (prod.cartKey ?? prod.sku) === cartKey)?.quantity || 0,
    );
    const [price, setPrice] = useState<number>(item.preco);
    const [discountedPrice, setDiscountedPrice] = useState<number | null>(null);
    const [aviseMeModal, setAviseMeModal] = useState<boolean>(false);
    const favoriteSKUs = useFavoritesStore(state => state.favoriteSKUs);
    const toggleFavoriteSKU = useFavoritesStore(state => state.toggleFavoriteSKU);
    const [isFav, setIsFav] = useState<boolean>(
      () => favoriteSKUs.has(item.sku),
    );

    useEffect(() => {
      setIsFav(favoriteSKUs.has(item.sku));
    }, [favoriteSKUs, item.sku]);

    const handleCloseModal = () => setAviseMeModal(false);
    const openModal = () => setAviseMeModal(true);


    useEffect(() => {
      const {price: nPrice, discountedPrice: ndiscountedPrice} =
        calculatePriceBasedOnQuantity(item, count);
      setPrice(nPrice);
      setDiscountedPrice(ndiscountedPrice);
    }, [count, item]);
    
     const { navigate } = useNavigation<NavigationProps>();

    useEffect(() => {
      setCount(products.find(prod => (prod.cartKey ?? prod.sku) === cartKey)?.quantity || 0);
    }, [products, cartKey]);

            const formatPriceRanges = useCallback((item: IProduct) => {
          const ranges = [];
        
          for (let i = 2; i <= 5; i++) {
            const volume = item[`faixaVolume${i}`];
            const rangePrice = item[`kdkg${i}`];
            if (volume && rangePrice) {
              const quantityNeeded = volume - count;
        
              if (quantityNeeded > 0) {
                ranges.push({
                  quantityNeeded,
                  rangePrice: rangePrice.toFixed(2).replace('.', ','),
                });
              }
            }
          }
        
          return ranges;
        }, [count]);
        const priceRanges = useMemo(() => formatPriceRanges(item), [item, formatPriceRanges]);


    const getStockStatusColor = useCallback((stock: number) => {
      if (stock > 200) {
        return '#21ce2f';
      } else if (stock > 0 && stock <= 200) {
        return '#fb6340';
      } else {
        return '#ec1f24';
      }
    }, []);
const getLowestPrice = useCallback((item: IProduct) => {
  let lowestPrice = item.preco;

  for (let i = 2; i <= 5; i++) {
    const rangePrice = item[`kdkg${i}`];
    if (rangePrice && rangePrice < lowestPrice) {
      lowestPrice = rangePrice;
    }
  }

  // Retorna null se o menor preço for igual ao preço original
  return lowestPrice !== item.preco ? lowestPrice.toFixed(2).replace('.', ',') : null;
}, []);

  const createNotification =  useCallback((item: IProduct)  => {
    StockNotificationService.createStockNotification(item.sku, item.descricao);
  }, []);


  const toogleFavorite = useCallback(async () => {
    if (!clientCode) return;
    const next = !isFav;
    setIsFav(next);
    toggleFavoriteSKU(item.sku);
    try {
      await ProductFavoriteService.toggleFavorite(clientCode, item.sku);
    } catch {
      setIsFav(!next);
      toggleFavoriteSKU(item.sku);
    }
  }, [clientCode, isFav, item.sku, toggleFavoriteSKU]);



    const formatPrice = useCallback((price: string) => {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(parseFloat(price));
    }, []);
    return (
      <View style={[styles.containerOneI, containerStyle]}>
        <View style={{ position: 'relative' }}>
              {!hideFavoriteButton && (
                <TouchableOpacity
                  onPress={toogleFavorite}
                  style={{position: 'absolute', top: 4, right: 4, zIndex: 2, padding: 4}}>
                  <Ionicons
                    name={isFav ? 'heart' : 'heart-outline'}
                    size={22}
                    color={isFav ? '#ED4956' : '#CCCCCC'}
                  />
                </TouchableOpacity>
              )}
            {!hideFavoriteButton ? (
              <View style={{alignSelf: 'center', position: 'relative'}}>
                <TouchableOpacity
                  onPress={() => {
                    navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
                  }}>
                  <Image
                    source={image ? {uri: image} : Images.emptyImgIcon}
                    style={image ? styles.imageStyle : styles.emptyImageStyle}
                  />
                </TouchableOpacity>
                {item.is_promotion && <PromotionBadge />}
              </View>
            ) : (
              <>
                <TouchableOpacity
                  onPress={() => {
                    navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
                  }}>
                  <Image
                    source={image ? {uri: image} : Images.emptyImgIcon}
                    style={image ? styles.imageStyle : styles.emptyImageStyle}
                  />
                </TouchableOpacity>
                {item.is_promotion && <PromotionBadge />}
              </>
            )}
        </View>
        <TouchableOpacity
          onPress={() => {
            navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
          }}
        >
          <Text numberOfLines={4} style={styles.description}>
            {description}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
          }}
        >
          <View style={styles.infoContainer}>
            <Text numberOfLines={1} style={styles.price}>
              {formatPrice(
                discountedPrice
                  ? discountedPrice.toFixed(2).toString()
                  : price.toFixed(2).toString(),
              )}
            </Text>
            <Text
              style={[
                styles.hasItem,
                {color: getStockStatusColor(item?.estoque)},
              ]}>
              {item?.estoque > 200
                ? 'Disponível'
                : item?.estoque > 0 && item?.estoque <= 200
                ? 'Estoque baixo'
                : 'Indisponível'}
            </Text>
          </View>
        </TouchableOpacity>

      {item?.estoque > 0 && getLowestPrice(item) && (
      <TouchableOpacity
        style={styles.priceHighlightContainer}
        onPress={() => {
          navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
        }}
      >
    <Text style={styles.priceHighlightText}>
      Pague até{' '}
      <Text style={styles.highlightedPrice}>R$ {getLowestPrice(item)}</Text> por caixa!
    </Text>
  </TouchableOpacity>

  )}
    <TouchableOpacity
        onPress={() => {
          navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
        }}
      >
      <Text style={styles.highlightedPrice}>Ver mais</Text>
    </TouchableOpacity>
        {(() => {
          const otherQty = products.find(p => (p.cartKey ?? p.sku) === otherKey)?.quantity ?? 0;
          const effectiveMax = Math.max(0, (item?.maximum ? item?.maximum : item?.estoque) - otherQty);
          const currentQty = products.find(p => (p.cartKey ?? p.sku) === cartKey)?.quantity ?? 0;

          if (item?.estoque > 0) {
            return (
              <View style={styles.footer}>
                <Counter
                  key={cartKey}
                  onPress={(val: number) => AddBag(val)}
                  quantity={currentQty}
                  item={item}
                  decrement={(val: number) => setCount(val)}
                  increment={(val: number) => setCount(val)}
                  directionButton="column"
                  buttonWidth="100%"
                  max={effectiveMax}
                  hasRanges
                  hasButton={false}
                />
              </View>
            );
          }

          return (
            <View style={{marginTop: 'auto'}}>
              <ButtonComponent
                title="Avise-me"
                width="100%"
                onPress={() => openModal()}
              />
            </View>
          );
        })()}
         <AviseMeModal
          onPress={handleCloseModal}
          sku={item.sku}
          descricao={item.descricao}
          visible={aviseMeModal}
        />
      </View>
    );
  },
);

export default ProductList;
